module.exports = __webpack_public_path__ + "img/logo_letras.2f37cb78.png";